// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { CombinedGraphQLErrors } from "@apollo/client/errors";
import { EGraphQLErrorCode, EGraphQLInternalErrorMessage, } from "@sequentech/ui-core";
import { isApolloTransportError } from "./ApolloErrors";
import { CastBallotsErrorType } from "./VotingPortalError";
// The review screen's text for a ballot the ballot box did not accept, whether
// it was being received or cast.
export var castVoteErrorMessage = function (error, t) {
    var _a, _b, _c, _d, _e, _f;
    var castError = error;
    var errorExtensions = (CombinedGraphQLErrors.is(error)
        ? (_a = error.errors[0]) === null || _a === void 0 ? void 0 : _a.extensions
        : (_c = (_b = castError === null || castError === void 0 ? void 0 : castError.graphQLErrors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.extensions);
    if ((_d = castError === null || castError === void 0 ? void 0 : castError.message) === null || _d === void 0 ? void 0 : _d.includes("internal error")) {
        return t("reviewScreen.error.".concat(CastBallotsErrorType.INTERNAL_ERROR)); // can happen if the backend panics
    }
    else if (errorExtensions === null || errorExtensions === void 0 ? void 0 : errorExtensions.code) {
        var errorCode = errorExtensions === null || errorExtensions === void 0 ? void 0 : errorExtensions.code;
        console.log(castError.name, castError.message);
        var internalErrMessage = (_f = (_e = errorExtensions === null || errorExtensions === void 0 ? void 0 : errorExtensions.internal) === null || _e === void 0 ? void 0 : _e.error) === null || _f === void 0 ? void 0 : _f.message;
        console.log(errorCode, internalErrMessage);
        if (errorCode === EGraphQLErrorCode.UNEXPECTED &&
            internalErrMessage === EGraphQLInternalErrorMessage.TIMEOUT_ERROR) {
            return t("reviewScreen.error.".concat(CastBallotsErrorType.CAST_VOTE_TIMEOUT));
        }
        return t("reviewScreen.error.".concat(CastBallotsErrorType.CAST_VOTE, "_").concat(errorCode));
    }
    else if (isApolloTransportError(error instanceof Error ? error : undefined) ||
        (error && typeof error === "object" && "networkError" in error && error.networkError)) {
        return t("reviewScreen.error.".concat(CastBallotsErrorType.NETWORK_ERROR));
    }
    return t("reviewScreen.error.".concat(CastBallotsErrorType.CAST_VOTE)); // Generic error
};
